import Glenview1 from '../../Media/Logo Ciputra Cibubur/Glenview.png'
import Glenview2 from '../../Media/Logo Ciputra Cibubur/Glenview.png'

const Glenviewimages =[
Glenview1, Glenview2,
]

export default Glenviewimages;